import { Store } from "../../reducers/store";

export const getState = (property) => {
    return Store.getState().data[property];
};
